import React from "react";
import { useStateValue } from "../StateProvider";
import "./details.scss";

const Details = ({ title, id, rating, price, image }) => {
  const [basket, dispatch] = useStateValue();
  const addtoBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
      },
    });
  };

  return (
    <>
      <h4 className="mb-5">The Details of {title}</h4>
      <div className="row">
        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
          <div className="detail__img">
            <img src={image} alt={title} />
          </div>
          <div className="thumbnail_img">
            <img src={image} alt="" />
            <img src={image} alt="" />
            <img src={image} alt="" />
          </div>
        </div>
        <div className="col-lg-5 offset-lg-1 col-md-5 offset-md-1 col-sm-12 col-xs-12">
          <div className="detail__body">
            <h4>{title}</h4>

            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>

            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Earum
              magnam dolorum maxime tempora molestias assumenda numquam, fuga
              facilis voluptatem eius.
            </p>

            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
            <p className="d-flex card__rating">
              Rating:{" "}
              {Array(rating)
                .fill()
                .map((_) => (
                  <img
                    src="https://img.icons8.com/material-outlined/16/000000/star--v3.png"
                    alt=""
                  />
                ))}
            </p>
            <p className="card-text">$ {price}/kg</p>

            <button
              type="button"
              className="addtocart__btn mb-5"
              onClick={addtoBasket}
            >
              Add to cart
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Details;
